// ─────────────────────────────────────────────────────────────
// Auth.js — Elite Scholastics Role-Based Access Control
// In production: passwords hashed (bcrypt), users live in DB
// ─────────────────────────────────────────────────────────────

export const USERS = [
  // Administrators
  { id:"ADM001", name:"Dr. Patricia Moore", email:"pmoore@school.edu",    password:"admin123",   role:"admin",   title:"Principal",         grades:"K-8",  subject:"All",      avatar:"PM", color:"#1A6EBD" },
  { id:"ADM002", name:"James Carter",       email:"jcarter@school.edu",   password:"admin123",   role:"admin",   title:"Asst. Principal",   grades:"K-8",  subject:"All",      avatar:"JC", color:"#1A6EBD" },
  { id:"ADM003", name:"Sandra Lee",         email:"slee@school.edu",      password:"admin123",   role:"admin",   title:"Data Coordinator",  grades:"K-8",  subject:"All",      avatar:"SL", color:"#7C3AED" },
  // Teachers
  { id:"TCH001", name:"Maria Rivera",       email:"mrivera@school.edu",   password:"teacher123", role:"teacher", title:"ELA Teacher",       grades:"3-4",  subject:"ELA",      avatar:"MR", color:"#00A878" },
  { id:"TCH002", name:"James Thompson",     email:"jthompson@school.edu", password:"teacher123", role:"teacher", title:"Math Teacher",      grades:"4-5",  subject:"Math",     avatar:"JT", color:"#00A878" },
  { id:"TCH003", name:"Aisha Patel",        email:"apatel@school.edu",    password:"teacher123", role:"teacher", title:"ELA/Math Teacher",  grades:"5-6",  subject:"ELA/Math", avatar:"AP", color:"#00A878" },
  { id:"TCH004", name:"Carlos Brooks",      email:"cbrooks@school.edu",   password:"teacher123", role:"teacher", title:"Math Teacher",      grades:"6-7",  subject:"Math",     avatar:"CB", color:"#00A878" },
  { id:"TCH005", name:"Sarah Kim",          email:"skim@school.edu",      password:"teacher123", role:"teacher", title:"ELA Teacher",       grades:"6",    subject:"ELA",      avatar:"SK", color:"#00A878" },
  { id:"TCH006", name:"David Torres",       email:"dtorres@school.edu",   password:"teacher123", role:"teacher", title:"Math Teacher",      grades:"7-8",  subject:"Math",     avatar:"DT", color:"#00A878" },
];

export const PERMISSIONS = {
  admin: {
    canViewAdminDashboard: true,
    canViewAllTeachers:    true,
    canViewAllStudents:    true,
    canViewTeacherStudio:  true,
    canFilterByTeacher:    true,
    canViewObservations:   true,
    canViewValueAdd:       true,
    canExportData:         true,
    canViewIEPAlerts:      true,
  },
  teacher: {
    canViewAdminDashboard: false,
    canViewAllTeachers:    false,
    canViewAllStudents:    false,
    canViewTeacherStudio:  true,
    canFilterByTeacher:    false,
    canViewObservations:   false,
    canViewValueAdd:       false,
    canExportData:         false,
    canViewIEPAlerts:      false,
  },
};

export function login(email, password) {
  const user = USERS.find(
    u => u.email.toLowerCase() === email.toLowerCase().trim()
      && u.password === password
  );
  if (!user) return { success: false, error: "Invalid email or password." };
  const session = { ...user };
  delete session.password;
  return { success: true, user: session };
}

export function hasPermission(user, permission) {
  if (!user) return false;
  return PERMISSIONS[user.role]?.[permission] ?? false;
}

export function canAccessTeacher(currentUser, teacherId) {
  if (!currentUser) return false;
  if (currentUser.role === "admin") return true;
  return currentUser.id === teacherId;
}

export function getAccessibleTeachers() {
  return USERS.filter(u => u.role === "teacher");
}
